import React, { useState, useEffect } from 'react';
import ImagesPallet from '../../../utils/ImagesPallet';
import { ChevronLeft, ChevronRight, Maximize2 } from 'lucide-react';
import JoinButton from '../../../components/academy/packages/JoinButton';

import ModalSection from './components/ModalSection';

function SecondSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
 const [isAutoPlaying, setIsAutoPlaying] = useState(true);
 const [showModal, setShowModal] = useState(false);
 const [modalImageIndex, setModalImageIndex] = useState(0);

  const images = [
  { url: ImagesPallet.HeroFirstSection, alt: "Slide 1" },
  { url: ImagesPallet.HeroSectionAbout2, alt: "Slide 2" },
  { url: ImagesPallet.HeroSectionAbout3, alt: "Slide 3" },
  { url: ImagesPallet.HeroSectionAbout4, alt: "Slide 4" },
 ];

 // Auto-play functionality
   useEffect(() => {
     let interval;
     if (isAutoPlaying) {
       interval = setInterval(() => {
         setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
       }, 3000);
     }
     return () => clearInterval(interval);
   }, [isAutoPlaying, images.length]);
 
   const nextSlide = () => {
     setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
   };
 
   const prevSlide = () => {
     setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
   };
 
   const goToSlide = (index) => {
     setCurrentIndex(index);
 };
 
 const nextModalImage = () => {
    setModalImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevModalImage = () => {
    setModalImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const openModal = (index) => {
    setModalImageIndex(index);
    setShowModal(true);
    setIsAutoPlaying(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setIsAutoPlaying(true);
  };

  return (
    <>
      <div className="container mx-auto px-6 pt-16 h-115 sm:h-120 md:h-115 ">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left side - Content */}
          <div className="lg:w-1/2 space-y-10">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight">
              Join Our Training <span className="text-blue-600">Academy</span>
            </h2>
            <div className="space-y-4">
              <p className="text-lg text-gray-600 leading-relaxed indent-5">
               Papakilo Academy bukan sekadar pusat pelatihan, melainkan investasi bagi pengembangan Sumber Daya Manusia (SDM) yang terampil dan profesional di industri barbershop. Kami berkomitmen untuk menyediakan pelatihan komprehensif yang mencakup berbagai peran penting, mulai dari kasir dan receptionist yang ramah dan efisien, hingga office boy yang handal, supervisor yang cakap, dan tentu saja, kapster yang menjadi ujung tombak kesuksesan sebuah barbershop.
             </p>
             <p className="text-lg text-gray-600 leading-relaxed indent-5">
               Di Papakilo Academy, kami memahami bahwa kapster yang berkualitas adalah aset berharga. Program pelatihan kapster kami dirancang secara khusus untuk menghasilkan lulusan yang tidak hanya terampil, tetapi juga bersertifikasi dan siap bersaing di industri yang semakin kompetitif.
             </p>
            </div>
            <div className="pt-4">
              <JoinButton />
            </div>
          </div>

          {/* Right side - Image Slider */}
          <div className="lg:w-1/2 relative group">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              {/* Images */}
              <div 
                className="flex transition-transform duration-700 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {images.map((image, index) => (
                  <div 
                    key={index} 
                    className="relative w-full flex-shrink-0 cursor-pointer group"
                    onClick={() => openModal(index)}
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-[500px] object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                    <button 
                      className="absolute top-4 right-4 p-2 bg-white/80 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <Maximize2 className="w-5 h-5" />
                    </button>
                  </div>
                ))}
              </div>

              {/* Navigation arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all opacity-0 group-hover:opacity-100 hover:scale-110"
                onMouseEnter={() => setIsAutoPlaying(false)}
                onMouseLeave={() => setIsAutoPlaying(true)}
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-3 rounded-full shadow-lg transition-all opacity-0 group-hover:opacity-100 hover:scale-110"
                onMouseEnter={() => setIsAutoPlaying(false)}
                onMouseLeave={() => setIsAutoPlaying(true)}
              >
                <ChevronRight className="w-6 h-6" />
              </button>

              {/* Progress bar */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-white/30">
                <div 
                  className="h-full bg-blue-500 transition-all duration-300 ease-out"
                  style={{ width: `${((currentIndex + 1) / images.length) * 100}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <ModalSection 
        isOpen={showModal}
        onClose={closeModal}
        images={images}
        currentIndex={modalImageIndex}
        onPrevious={prevModalImage}
        onNext={nextModalImage}
      />
    </>
  )
}

export default SecondSection